/*
 * DrillWriter Studio
 * Author: Jasper Hamilton
 * AI assistance: Portions of this code and its documentation were generated
 *   or refined using AI tools under human direction.
 * Attribution: Credit to the original author in derivative works is
 *   appreciated as a courtesy. It is not required by the license; see NOTICE.
 * Created: 2026-08-21  ·  Last modified: 2026-08-22
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * What this application is called, and who made it.
 *
 * One definition, because a name appears in more places than anyone expects:
 * the wordmark, the browser tab, the PDF producer field, three error messages,
 * the pop-out window's title bar, and the About box. Renaming the application
 * with a find-and-replace leaves two of those behind every time.
 */

export const APP_NAME = 'DrillWriter Studio';

/** Short form, for places where the full name will not fit. */
export const APP_SHORT_NAME = 'DrillWriter';

export const APP_AUTHOR = 'Jasper Hamilton';

/** First written. */
export const APP_YEAR = 2026;
export const APP_CREATED = '21 August 2026';

/**
 * Kept in step with package.json by a test — the two drift otherwise, and the
 * version in an About box is worth nothing if nobody trusts it.
 */
export const APP_VERSION = '0.1.0';

export const APP_LICENSE = 'Apache-2.0';

/** The one-line copyright, as it should appear wherever one is shown. */
export const APP_COPYRIGHT = `© ${APP_YEAR} ${APP_AUTHOR}`;

/**
 * The disclosure that AI tools were used. Worded as it is in NOTICE and in
 * every file header, so the three cannot come to say different things.
 */
export const APP_AI_NOTICE =
  'Portions of this software and its documentation were generated or refined ' +
  'using AI tools under human direction.';

export const APP_ATTRIBUTION_REQUEST =
  `Crediting ${APP_AUTHOR} as the original author in derivative or ` +
  'redistributed works is appreciated. This is a courtesy request rather than ' +
  'a licensing term.';
